export const SortType = {
  DEFAULT: 'default',
  PRICE: 'price',
  TIME: 'time',
};
